import { AxiosResponse } from 'axios'
import { makeAPIRequest } from '../utils/request';
import { ROLES } from '../utils/constants';
import { AddUpdateGuidFormData } from '../components/Guides/AddGuide';

interface getAllGuidesParams {
  page: number;
  pageSize: number;
  searchData: {
    roles: string[], searchTerm: string
  }
};

interface getAllGuidesResponse {
  count: number;
  rows: [];
};

interface CommonResponse {
  data:{}
};

class GuideAPI {

    async getAllGuides(params: getAllGuidesParams): Promise<getAllGuidesResponse> {
        const jwt = localStorage.getItem('access-token')
        const offset = params.page * params.pageSize;
        const limit = params.pageSize;
        const roleName = [ROLES.GUIDE];
        const searchTerm = params?.searchData?.searchTerm || "";
        const res: AxiosResponse = await makeAPIRequest({
          method: 'GET',
          url: `/api/users?offset=${offset}&limit=${limit}&roleName=${roleName}&name=${searchTerm}`,
          headers: {
            Authorization: `Bearer ${jwt}`,
          },
        })
        return res.data.data
    };

    async createGuide(data: AddUpdateGuidFormData): Promise<CommonResponse> {
        const jwt = localStorage.getItem('access-token')
        const res: AxiosResponse = await makeAPIRequest({
          method: 'POST',
          url: `/api/users/invite`,
          data,
          headers: {
            Authorization: `Bearer ${jwt}`,
          },
        })
        return res.data
    };

    async updateGuide(userId: string, data: AddUpdateGuidFormData): Promise<CommonResponse> {
        const jwt = localStorage.getItem('access-token')
        const res: AxiosResponse = await makeAPIRequest({
          method: 'PUT',
          url: `/api/users/${userId}`,
          data,
          headers: {
            Authorization: `Bearer ${jwt}`,
          },
        })
        return res.data
    };

    async enabledDisabledGuide(userId: string, data: {enabled: boolean}): Promise<CommonResponse> {
        const jwt = localStorage.getItem('access-token')
        const res: AxiosResponse = await makeAPIRequest({
          method: 'PUT',
          url: `/api/users/${userId}/activateOrDeactivateAccount`,
          data,
          headers: {
            Authorization: `Bearer ${jwt}`,
          },
        })
        return res.data
    };

}

const guideApi = new GuideAPI();
export default guideApi;